import { useRef, useEffect, useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useDebounceFn(fn, delay) {
    const timeoutIdRef = useRef(null);
    const fnRef = useRef(fn);
    // Always keep the latest function reference
    useEffect(() => {
        fnRef.current = fn;
    }, [fn]);
    useEffect(() => {
        return () => {
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
            }
        };
    }, []);
    return useCallback((...args) => {
        // Clear previous timeout if it exists
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
        }
        // Set new timeout
        timeoutIdRef.current = setTimeout(() => {
            fnRef.current(...args);
            timeoutIdRef.current = null; // Clear ref after execution
        }, delay);
    }, [delay]);
}
export default useDebounceFn;
